import React from 'react'
import Moment from 'moment'
import { Pill } from '@myxplor/ui'

const displayTime = time => Moment(time, 'HH:mm:ss').format('h:mma')

const defaultShowWarningsFun = isHourlySession => () => isHourlySession

const displayPillTitle = ({ isHourlySession, pillTitle }) => {
  if (pillTitle) return pillTitle
  return isHourlySession ? 'This is an hourly session' : ''
}

const ScheduledSession = ({
  session,
  isHourlySession,
  showWarningFun = defaultShowWarningsFun(isHourlySession),
}) => (
  <li className="weekDay--session">
    <Pill
      warning={showWarningFun(session)}
      title={displayPillTitle({ pillTitle: session.pillTitle, isHourlySession })}
      noUpperCase>
      {displayTime(session.startTime)} - {displayTime(session.endTime)}, ${session.standardAmount}
      {isHourlySession && '/hr'}
      {session.message && <div>{session.message}</div>}
    </Pill>
  </li>
)

export default ScheduledSession



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/booking-schedules/views/session.jsx